<template>
    <div id="defaultBillingSettings">
        <a-card
            :title="
                $t('billing.currentPlanLabel', {
                    planName: ($_.get(settings, 'plan.selectedPlan') || '').toUpperCase(),
                    agentCount: $_.get(settings, 'plan.detail.maxAgentCount') || '',
                })
            "
            style="margin: 16px"
            v-if="settingsFetched && settings.plan"
        >
            <a slot="extra" href="#" @click="planVisible = !planVisible">
                <a-button style="color: white; background-color: dodgerblue">
                    {{ planVisible ? $t("billing.hidePlan") : $t("billing.changeCancelPlan") }}
                </a-button>
            </a>
            <ShopifyBillingDetails :header="false" v-show="planVisible" />
        </a-card>
        <a-card :title="$t('billing.paymentBilling')" style="margin: 16px">
            <div v-if="isShopify" class="d-flex justify-content-center align-items-center flex-column">
                <ShopifyIcon style="width: 100px; height: 100px" />
                <h3>
                    {{ $t("billing.informationShopping") }}
                </h3>
            </div>
            <div v-else>
                <div v-if="noBillingDetail && !createCardForm" class="no-card-info">
                    <iyzico-pay />
                    <h3 class="no-card-info-text">
                        {{ $t("billing.addCardIyzico") }}
                    </h3>
                    <a-button type="primary" @click="createCardForm = true">{{ $t("billing.addCard") }}</a-button>
                </div>
                <div v-else-if="createCardForm">
                    <b-form class="d-flex flex-column justify-content-center" @submit.prevent="handlePaymentMethodSave">
                        <b-row>
                            <b-col cols="5">
                                <b-row>
                                    <b-col md="12">
                                        <p>
                                            {{ $t("billing.billingDetails") }}
                                        </p>
                                    </b-col>
                                    <b-col md="6">
                                        <md-field
                                            :class="{
                                                'md-invalid': errors.first($t('billing.name')) != null,
                                            }"
                                        >
                                            <label>{{ $t("billing.name") }}</label>
                                            <md-input
                                                v-model="paymentMethod.name"
                                                v-validate="'required'"
                                                :name="$t('billing.name')"
                                                autocomplete="name"
                                            ></md-input>
                                            <span class="md-error">{{ errors.first($t("billing.name")) }}</span>
                                        </md-field>
                                    </b-col>
                                    <b-col md="6">
                                        <md-field
                                            :class="{
                                                'md-invalid': errors.first($t('billing.surname')) != null,
                                            }"
                                        >
                                            <label>{{ $t("billing.surname") }}</label>
                                            <md-input
                                                v-model="paymentMethod.surname"
                                                v-validate="'required'"
                                                :name="$t('billing.surname')"
                                                autocomplete="surname"
                                            ></md-input>
                                            <span class="md-error">{{ errors.first($t("billing.surname")) }}</span>
                                        </md-field>
                                    </b-col>
                                    <b-col md="6">
                                        <md-field
                                            :class="{
                                                'md-invalid': errors.first($t('billing.email')) != null,
                                            }"
                                        >
                                            <label>{{ $t("billing.email") }}</label>
                                            <md-input
                                                v-model="paymentMethod.email"
                                                v-validate="'required'"
                                                :name="$t('billing.email')"
                                                autocomplete="email"
                                            ></md-input>
                                            <span class="md-error">{{ errors.first($t("billing.email")) }}</span>
                                        </md-field>
                                    </b-col>
                                    <b-col md="6">
                                        <md-field
                                            :class="{
                                                'md-invalid': errors.first($t('billing.identityNumber')) != null,
                                            }"
                                        >
                                            <label>{{ $t("billing.identityNumber") }}</label>
                                            <md-input
                                                v-model="paymentMethod.identityNumber"
                                                v-validate="'required'"
                                                :name="$t('billing.identityNumber')"
                                            ></md-input>
                                            <span class="md-error">{{
                                                errors.first($t("billing.identityNumber"))
                                            }}</span>
                                        </md-field>
                                    </b-col>
                                    <b-col md="6">
                                        <md-field
                                            :class="{
                                                'md-invalid': errors.first($t('billing.contactName')) != null,
                                            }"
                                        >
                                            <label>{{ $t("billing.contactName") }}</label>
                                            <md-input
                                                v-model="paymentMethod.contactName"
                                                v-validate="'required'"
                                                :name="$t('billing.contactName')"
                                            ></md-input>
                                            <span class="md-error">{{ errors.first($t("billing.contactName")) }}</span>
                                        </md-field>
                                    </b-col>
                                    <b-col md="6">
                                        <md-field
                                            :class="{
                                                'md-invalid': errors.first($t('billing.billingCountry')) != null,
                                            }"
                                        >
                                            <label>{{ $t("billing.billingCountry") }}</label>
                                            <md-input
                                                v-model="paymentMethod.billingCountry"
                                                v-validate="'required'"
                                                :name="$t('billing.billingCountry')"
                                                autocomplete="shipping country"
                                            ></md-input>
                                            <span class="md-error">{{
                                                errors.first($t("billing.billingCountry"))
                                            }}</span>
                                        </md-field>
                                    </b-col>
                                    <b-col md="6">
                                        <md-field
                                            :class="{
                                                'md-invalid': errors.first($t('billing.billingCity')) != null,
                                            }"
                                        >
                                            <label>{{ $t("billing.billingCity") }}</label>
                                            <md-input
                                                v-model="paymentMethod.billingCity"
                                                v-validate="'required'"
                                                :name="$t('billing.billingCity')"
                                                autocomplete="shipping region"
                                            ></md-input>
                                            <span class="md-error">{{ errors.first($t("billing.billingCity")) }}</span>
                                        </md-field>
                                    </b-col>
                                    <b-col md="12">
                                        <md-field
                                            :class="{
                                                'md-invalid': errors.first($t('billing.billingAddress')) != null,
                                            }"
                                        >
                                            <label>{{ $t("billing.billingAddress") }}</label>
                                            <md-input
                                                v-model="paymentMethod.billingAddress"
                                                v-validate="'required'"
                                                :name="$t('billing.billingAddress')"
                                                autocomplete="shipping locality"
                                            ></md-input>
                                            <span class="md-error">{{
                                                errors.first($t("billing.billingAddress"))
                                            }}</span>
                                        </md-field>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col cols="1" class="d-flex align-items-center justify-content-center">
                                <a-divider type="vertical" style="height: 100%" />
                            </b-col>
                            <b-col cols="6">
                                <b-row>
                                    <b-col md="12">
                                        <p>
                                            {{ $t("billing.cardInfo") }}
                                        </p>
                                    </b-col>
                                    <b-col md="6">
                                        <md-field
                                            :class="{
                                                'md-invalid': errors.first($t('billing.cardAlias')) != null,
                                            }"
                                        >
                                            <label>{{ $t("billing.cardAlias") }}</label>
                                            <md-input
                                                v-model="paymentMethod.cardAlias"
                                                v-validate="'required'"
                                                :name="$t('billing.cardAlias')"
                                            ></md-input>
                                            <span class="md-error">{{ errors.first($t("billing.cardAlias")) }}</span>
                                        </md-field>
                                    </b-col>
                                    <b-col md="6">
                                        <md-field
                                            :class="{
                                                'md-invalid': errors.first($t('billing.cardHolderName')) != null,
                                            }"
                                        >
                                            <label>{{ $t("billing.cardHolderName") }}</label>
                                            <md-input
                                                v-model="paymentMethod.cardHolderName"
                                                v-validate="'required'"
                                                :name="$t('billing.cardHolderName')"
                                                autocomplete="cc-name"
                                            ></md-input>
                                            <span class="md-error">{{
                                                errors.first($t("billing.cardHolderName"))
                                            }}</span>
                                        </md-field>
                                    </b-col>
                                    <b-col md="6">
                                        <md-field
                                            :class="{
                                                'md-invalid': errors.first($t('billing.cardNumber')) != null,
                                            }"
                                        >
                                            <label>{{ $t("billing.cardNumber") }}</label>
                                            <md-input
                                                v-model="paymentMethod.cardNumber"
                                                v-validate="'required'"
                                                :name="$t('billing.cardNumber')"
                                                autocomplete="cc-number"
                                            ></md-input>
                                            <span class="md-error">{{ errors.first($t("billing.cardNumber")) }}</span>
                                        </md-field>
                                    </b-col>
                                    <b-col md="3">
                                        <md-field
                                            :class="{
                                                'md-invalid': errors.first($t('billing.expireMonth')) != null,
                                            }"
                                        >
                                            <label :for="$t('billing.expireMonth')">{{
                                                $t("billing.expireMonth")
                                            }}</label>
                                            <md-select
                                                v-model="paymentMethod.expireMonth"
                                                :name="$t('billing.expireMonth')"
                                                :id="$t('billing.expireMonth')"
                                                v-validate="'required'"
                                            >
                                                <md-option v-for="i in 12" :key="i" :value="i + ''">{{ i }}</md-option>
                                            </md-select>
                                            <span class="md-error">{{ errors.first($t("billing.expireMonth")) }}</span>
                                        </md-field>
                                    </b-col>
                                    <b-col md="3">
                                        <md-field
                                            :class="{
                                                'md-invalid': errors.first($t('billing.expireYear')) != null,
                                            }"
                                        >
                                            <label :for="$t('billing.expireYear')">{{
                                                $t("billing.expireYear")
                                            }}</label>
                                            <md-select
                                                v-model="paymentMethod.expireYear"
                                                :name="$t('billing.expireYear')"
                                                :id="$t('billing.expireYear')"
                                                v-validate="'required'"
                                            >
                                                <md-option
                                                    v-for="(n, i) in 10"
                                                    :key="i"
                                                    :value="getCurrentYear + i + ''"
                                                    >{{ getCurrentYear + i }}
                                                </md-option>
                                            </md-select>
                                            <span class="md-error">{{ errors.first($t("billing.expireYear")) }}</span>
                                        </md-field>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>

                        <div class="d-flex justify-content-end">
                            <b-button :disabled="cardSaveLoading" type="submit" variant="primary" class="mr-2">
                                <template v-if="cardSaveLoading">
                                    <font-awesome-icon icon="spinner" spin />
                                    <span>{{ $t("billing.saving") }}</span>
                                </template>
                                <template v-else>
                                    <span>{{ $t("billing.save") }}</span>
                                </template>
                            </b-button>
                            <b-button @click="createCardForm = false">
                                <template>
                                    {{ $t("billing.cancel") }}
                                </template>
                            </b-button>
                        </div>
                    </b-form>
                </div>

                <div v-if="!noBillingDetail" class="billing-card-info">
                    <div class="d-flex align-items-center">
                        <div>
                            <div class="billing-card-title">{{ $t("billing.paymentMethod") }}</div>
                            <div
                                class="
                                    billing-card-content
                                    d-flex
                                    align-content-center align-items-center
                                    justify-content-center
                                "
                            >
                                <md-icon style="color: #40a9ff">payment</md-icon>
                                {{
                                    $t("billing.startWith", {
                                        binNumber: billingDetail.binNumber,
                                        cardFamily: billingDetail.cardAssociation,
                                    })
                                }}
                            </div>
                        </div>
                        <a-button style="margin-left: auto" type="primary" @click="$bvModal.show('update-card-form')"
                            >{{ $t("billing.updateCard") }}
                        </a-button>
                    </div>
                    <a-divider />
                    <div class="d-flex justify-content-center">
                        <div class="mr-5">
                            <div class="billing-card-title">{{ $t("billing.billingAddress") }}</div>
                            <div class="billing-card-content">
                                {{ billingDetail.billingAddress }}
                            </div>
                            <div class="billing-card-content">
                                {{ billingDetail.billingCity }}/{{ billingDetail.billingCountry }}
                            </div>
                        </div>
                        <div class="mr-5">
                            <div class="billing-card-title">{{ $t("billing.name") }}</div>
                            <div class="billing-card-content">{{ billingDetail.name }} {{ billingDetail.surname }}</div>
                        </div>
                        <div class="mr-5">
                            <div class="billing-card-title">{{ $t("billing.email") }}</div>
                            <div class="billing-card-content">{{ billingDetail.email }}</div>
                        </div>
                        <a-button
                            style="margin-left: auto; align-self: center"
                            type="primary"
                            @click="$bvModal.show('update-billing-form')"
                            >{{ $t("billing.updateBilling") }}
                        </a-button>
                    </div>
                </div>
            </div>
        </a-card>
        <a-card title="Invoices" style="margin: 16px">
            <InvoiceList :site-address="site.clientAddress" />
        </a-card>

        <div
            v-if="isAdmin"
            v-b-modal.invoice-form
            class="fab d-flex justify-content-center align-items-center"
            @click="editMode = false"
        >
            <md-icon class="">add</md-icon>
        </div>
        <b-modal
            id="update-card-form"
            :title="$t('billing.updateCard')"
            centered
            hide-footer
            size="lg"
            @hidden="hideModal('update-card-form')"
        >
            <b-form class="d-flex flex-column justify-content-center" @submit.prevent="handleCardUpdate">
                <b-row>
                    <b-col md="6">
                        <md-field
                            :class="{
                                'md-invalid': errors.first($t('billing.cardAlias')) != null,
                            }"
                        >
                            <label>{{ $t("billing.cardAlias") }}</label>
                            <md-input
                                v-model="paymentMethod.cardAlias"
                                v-validate="'required'"
                                :name="$t('billing.cardAlias')"
                            ></md-input>
                            <span class="md-error">{{ errors.first($t("billing.cardAlias")) }}</span>
                        </md-field>
                    </b-col>
                    <b-col md="6">
                        <md-field
                            :class="{
                                'md-invalid': errors.first($t('billing.cardHolderName')) != null,
                            }"
                        >
                            <label>{{ $t("billing.cardHolderName") }}</label>
                            <md-input
                                v-model="paymentMethod.cardHolderName"
                                v-validate="'required'"
                                :name="$t('billing.cardHolderName')"
                            ></md-input>
                            <span class="md-error">{{ errors.first($t("billing.cardHolderName")) }}</span>
                        </md-field>
                    </b-col>
                    <b-col md="6">
                        <md-field
                            :class="{
                                'md-invalid': errors.first($t('billing.cardNumber')) != null,
                            }"
                        >
                            <label>{{ $t("billing.cardNumber") }}</label>
                            <md-input
                                v-model="paymentMethod.cardNumber"
                                v-validate="'required'"
                                :name="$t('billing.cardNumber')"
                            ></md-input>
                            <span class="md-error">{{ errors.first($t("billing.cardNumber")) }}</span>
                        </md-field>
                    </b-col>
                    <b-col md="3">
                        <md-field
                            :class="{
                                'md-invalid': errors.first($t('billing.expireMonth')) != null,
                            }"
                        >
                            <label :for="$t('billing.expireMonth')">{{ $t("billing.expireMonth") }}</label>
                            <md-select
                                v-model="paymentMethod.expireMonth"
                                :name="$t('billing.expireMonth')"
                                :id="$t('billing.expireMonth')"
                                v-validate="'required'"
                            >
                                <md-option v-for="i in 12" :key="i" :value="i + ''">{{ i }}</md-option>
                            </md-select>
                            <span class="md-error">{{ errors.first($t("billing.expireMonth")) }}</span>
                        </md-field>
                    </b-col>
                    <b-col md="3">
                        <md-field
                            :class="{
                                'md-invalid': errors.first($t('billing.expireYear')) != null,
                            }"
                        >
                            <label :for="$t('billing.expireYear')">{{ $t("billing.expireYear") }}</label>
                            <md-select
                                v-model="paymentMethod.expireYear"
                                :name="$t('billing.expireYear')"
                                :id="$t('billing.expireYear')"
                                v-validate="'required'"
                            >
                                <md-option v-for="(n, i) in 10" :key="i" :value="getCurrentYear + i + ''"
                                    >{{ getCurrentYear + i }}
                                </md-option>
                            </md-select>
                            <span class="md-error">{{ errors.first($t("billing.expireYear")) }}</span>
                        </md-field>
                    </b-col>
                    <b-col md="12">
                        <b-button :disabled="cardSaveLoading" type="submit" variant="primary">
                            <template v-if="!cardSaveLoading">
                                <span>
                                    {{ $t("billing.update") }}
                                </span>
                            </template>
                            <template v-else>
                                <font-awesome-icon icon="spinner" spin />

                                <span>
                                    {{ $t("billing.updating") }}
                                </span>
                            </template>
                        </b-button>
                        <b-button @click="$bvModal.hide('update-card-form')">
                            <template>
                                {{ $t("billing.cancel") }}
                            </template>
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
        <b-modal
            id="update-billing-form"
            :title="$t('billing.updateBilling')"
            centered
            hide-footer
            size="lg"
            @hidden="hideModal('update-billing-form')"
        >
            <b-form class="d-flex flex-column justify-content-center" @submit.prevent="handleBillingUpdate">
                <b-row>
                    <b-col md="6">
                        <md-field
                            :class="{
                                'md-invalid': errors.first($t('billing.name')) != null,
                            }"
                        >
                            <label>{{ $t("billing.name") }}</label>
                            <md-input
                                v-model="billingForm.name"
                                v-validate="'required'"
                                :name="$t('billing.name')"
                            ></md-input>
                            <span class="md-error">{{ errors.first($t("billing.name")) }}</span>
                        </md-field>
                    </b-col>
                    <b-col md="6">
                        <md-field
                            :class="{
                                'md-invalid': errors.first($t('billing.surname')) != null,
                            }"
                        >
                            <label>{{ $t("billing.surname") }}</label>
                            <md-input
                                v-model="billingForm.surname"
                                v-validate="'required'"
                                :name="$t('billing.surname')"
                            ></md-input>
                            <span class="md-error">{{ errors.first($t("billing.surname")) }}</span>
                        </md-field>
                    </b-col>
                    <b-col md="6">
                        <md-field
                            :class="{
                                'md-invalid': errors.first($t('billing.email')) != null,
                            }"
                        >
                            <label>{{ $t("billing.email") }}</label>
                            <md-input
                                v-model="billingForm.email"
                                v-validate="'required'"
                                :name="$t('billing.email')"
                            ></md-input>
                            <span class="md-error">{{ errors.first($t("billing.email")) }}</span>
                        </md-field>
                    </b-col>
                    <b-col md="6">
                        <md-field
                            :class="{
                                'md-invalid': errors.first($t('billing.identityNumber')) != null,
                            }"
                        >
                            <label>{{ $t("billing.identityNumber") }}</label>
                            <md-input
                                v-model="billingForm.identityNumber"
                                v-validate="'required'"
                                :name="$t('billing.identityNumber')"
                            ></md-input>
                            <span class="md-error">{{ errors.first($t("billing.identityNumber")) }}</span>
                        </md-field>
                    </b-col>
                    <b-col md="6">
                        <md-field
                            :class="{
                                'md-invalid': errors.first($t('billing.billingCountry')) != null,
                            }"
                        >
                            <label>{{ $t("billing.billingCountry") }}</label>
                            <md-input
                                v-model="billingForm.billingCountry"
                                v-validate="'required'"
                                :name="$t('billing.billingCountry')"
                            ></md-input>
                            <span class="md-error">{{ errors.first($t("billing.billingCountry")) }}</span>
                        </md-field>
                    </b-col>
                    <b-col md="6">
                        <md-field
                            :class="{
                                'md-invalid': errors.first($t('billing.billingCity')) != null,
                            }"
                        >
                            <label>{{ $t("billing.billingCity") }}</label>
                            <md-input
                                v-model="billingForm.billingCity"
                                v-validate="'required'"
                                :name="$t('billing.billingCity')"
                            ></md-input>
                            <span class="md-error">{{ errors.first($t("billing.billingCity")) }}</span>
                        </md-field>
                    </b-col>
                    <b-col md="12">
                        <md-field
                            :class="{
                                'md-invalid': errors.first($t('billing.billingAddress')) != null,
                            }"
                        >
                            <label>{{ $t("billing.billingAddress") }}</label>
                            <md-input
                                v-model="billingForm.billingAddress"
                                v-validate="'required'"
                                :name="$t('billing.expireYear')"
                            ></md-input>
                            <span class="md-error">{{ errors.first($t("billing.billingAddress")) }}</span>
                        </md-field>
                    </b-col>
                    <b-col md="12">
                        <b-button :disabled="cardSaveLoading" type="submit" variant="primary">
                            <template v-if="!cardSaveLoading">
                                <span>
                                    {{ $t("billing.update") }}
                                </span>
                            </template>
                            <template v-else>
                                <font-awesome-icon icon="spinner" spin />

                                <span>
                                    {{ $t("billing.updating") }}
                                </span>
                            </template>
                        </b-button>
                        <b-button @click="$bvModal.hide('update-card-form')">
                            <template>
                                {{ $t("billing.cancel") }}
                            </template>
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
        <b-modal
            id="invoice-form"
            :title="$t('billing.newInvoiceForm')"
            centered
            hide-footer
            size="lg"
            @hidden="hideModal('invoice-form')"
        >
            <a-alert
                v-if="$validator.errors.items.length && submitClicked"
                :message="$t('billing.error')"
                class="mb-2"
                showIcon
                type="error"
            >
                <div slot="description">
                    <div v-for="(err, index) in $validator.errors.items" :key="'err-' + index">
                        <span>
                            {{ err.msg }}
                        </span>
                    </div>
                </div>
            </a-alert>
            <b-form class="d-flex flex-column justify-content-center" @submit.prevent="handleSave">
                <b-row>
                    <b-col md="12">
                        <b-form-group :label="$t('billing.price')" label-for="inputPrice">
                            <b-form-input
                                id="inputPrice"
                                v-model="price"
                                v-validate="'required|decimal:2'"
                                :name="$t('billing.price')"
                                :placeholder="$t('billing.price')"
                                autocomplete="off"
                                trim
                                type="text"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-button :disabled="loading" type="submit" variant="primary">
                            <template v-if="!loading">
                                <span v-if="!editMode">
                                    {{ $t("billing.save") }}
                                </span>
                                <span v-else>
                                    {{ $t("billing.update") }}
                                </span>
                            </template>
                            <template v-else>
                                <font-awesome-icon icon="spinner" spin />
                                <span v-if="!editMode">
                                    {{ $t("billing.saving") }}
                                </span>
                                <span v-else>
                                    {{ $t("billing.updating") }}
                                </span>
                            </template>
                        </b-button>
                        <b-button @click="$bvModal.hide('invoice-form')">
                            <template>
                                {{ $t("billing.cancel") }}
                            </template>
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPencilAlt, faPlusCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import AppBreadCrumb from "../common/AppBreadCrumb";
import * as _ from "lodash";
import { log2 } from "../../utils/log2";
import ActionDelete from "../svg/ActionDelete";
import ActionEdit from "../svg/ActionEdit";
import Pagination from "../Pagination";
import ChatBar from "../ChatBar";
import { createInvoice, createPaymentMethod, getBillingDetail, updateBilling, updateCardInfo } from "../../api/billing";
import IyzicoPay from "../svg/IyzicoPay";
import ShopifyBillingDetails from "./ShopifyBillingDetails";
import ShopifyIcon from "../fast-initialize/svg/ShopifyIcon";
import InvoiceList from "./InvoiceList";
import SYSTEM_PUBSUB from "../../utils/systemPubSub";
library.add(faPencilAlt, faTimes, faPlusCircle);

const log = log2("DefaultBillingSettings");
export default {
    name: "DefaultBillingSettings",
    components: {
        ShopifyBillingDetails,
        AppBreadCrumb,
        ActionDelete,
        ActionEdit,
        Pagination,
        ChatBar,
        IyzicoPay,
        ShopifyIcon,
        InvoiceList,
    },
    data() {
        return {
            isBusy: true,
            loading: false,
            editMode: false,
            submitClicked: false,
            selectedWMType: null,
            searchText: undefined,
            price: 0,
            createCardForm: false,
            cardSaveLoading: false,
            noBillingDetail: false,
            planVisible: this.$route.query["charge_id"],
            billingForm: {
                name: "",
                surname: "",
                email: "",
                identityNumber: "",
                billingCountry: "",
                billingCity: "",
                billingAddress: "",
                billingContactName: "",
            },
            paymentMethod: {
                name: "",
                surname: "",
                email: "",
                identityNumber: "",
                billingCountry: "",
                billingCity: "",
                billingAddress: "",
                contactName: "",
                cardAlias: "",
                cardNumber: "",
                cardHolderName: "",
                expireMonth: "",
                expireYear: "",
            },
            billingDetail: {},
        };
    },
    computed: {
        ...mapState({
            languages: (state) => state.language.languages,
            site: (state) => state.site.site,
            settings: (state) => state.setting.settings,
            settingsFetched: (state) => state.setting.settings.initialized,
            defaultLang: (state) => state.setting.settings.language.clientDefault,
            isAdmin: (state) => state.auth.adminUser != null,
            isShopify: (state) => _.get(state.site.site, "partner.name") === "shopify",
        }),
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
        }),
        getCurrentYear() {
            const date = new Date();
            return date.getFullYear();
        },
    },
    methods: {
        read(obj, key) {
            return _.get(obj, key);
        },
        handleSave() {
            this.submitClicked = true;
            this.$validator.validateAll().then((isValid) => {
                if (isValid) {
                    this.loading = true;
                    createInvoice(this.price)
                        .then((response) => {
                            this.hideModal("invoice-form");
                            this.$toasted.show(this.$t("billing.invoiceCreated"), {
                                duration: 3000,
                                position: "bottom-center",
                            });
                            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.INVOICE_CREATED, response);
                        })
                        .catch((err) => {
                            console.error(err);
                            this.$toasted.error(this.$t("billing.errorOccurred"), {
                                duration: 3000,
                                position: "bottom-center",
                            });
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                } else {
                    this.loading = false;
                }
            });
        },
        hideModal(id) {
            this.$bvModal.hide(id);
        },
        handleCardUpdate() {
            this.$validator.validateAll().then((isValid) => {
                if (isValid) {
                    this.cardSaveLoading = true;
                    const payload = {
                        alias: this.paymentMethod.cardAlias,
                        holderName: this.paymentMethod.cardHolderName,
                        cardNumber: this.paymentMethod.cardNumber,
                        expireMonth: this.paymentMethod.expireMonth,
                        expireYear: this.paymentMethod.expireYear,
                    };
                    updateCardInfo(payload)
                        .then((response) => {
                            //todo add payment method
                            console.log("handlepaymentmethod", { data: response.data });
                            if (response.data) {
                                this.billingDetail = response.data;
                                this.$toasted.show(this.$t("billing.creditCardChanged"), {
                                    duration: 3000,
                                    position: "bottom-center",
                                });
                                this.hideModal("update-card-form");
                            } else {
                                this.$toasted.error(this.$t("billing.errorOccurred"), {
                                    duration: 3000,
                                    position: "bottom-center",
                                });
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                            this.$toasted.error(this.$t("billing.errorOccurred"), {
                                duration: 3000,
                                position: "bottom-center",
                            });
                        })
                        .finally(() => {
                            this.cardSaveLoading = false;
                        });
                } else {
                    this.cardSaveLoading = false;
                }
            });
        },
        handleBillingUpdate() {
            this.$validator.validateAll().then((isValid) => {
                if (isValid) {
                    this.cardSaveLoading = true;
                    updateBilling(this.billingForm)
                        .then((response) => {
                            if (response.data) {
                                this.billingDetail = response.data;
                                this.$toasted.show(this.$t("billing.billingAddressChanged"), {
                                    duration: 3000,
                                    position: "bottom-center",
                                });
                                this.hideModal("update-billing-form");
                            } else {
                                this.$toasted.error(this.$t("billing.errorOccurred"), {
                                    duration: 3000,
                                    position: "bottom-center",
                                });
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                            this.$toasted.error(this.$t("billing.errorOccurred"), {
                                duration: 3000,
                                position: "bottom-center",
                            });
                        })
                        .finally(() => {
                            this.cardSaveLoading = false;
                        });
                } else {
                    this.cardSaveLoading = false;
                }
            });
        },
        handlePaymentMethodSave() {
            this.$validator.validateAll().then((isValid) => {
                if (isValid) {
                    this.cardSaveLoading = true;
                    createPaymentMethod(this.paymentMethod)
                        .then((response) => {
                            //todo add payment method
                            console.log("handlepaymentmethod", { data: response.data });
                            if (response.data) {
                                this.billingDetail = response.data;
                                this.noBillingDetail = false;
                                this.createCardForm = false;
                                this.$toasted.show(this.$t("billing.paymentMethodAdded"), {
                                    duration: 3000,
                                    position: "bottom-center",
                                });
                            } else {
                                this.$toasted.error(this.$t("billing.paymentMethodAddError"), {
                                    duration: 3000,
                                    position: "bottom-center",
                                });
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                            this.$toasted.error(this.$t("billing.paymentMethodAddError"), {
                                duration: 3000,
                                position: "bottom-center",
                            });
                        })
                        .finally(() => {
                            this.cardSaveLoading = false;
                        });
                } else {
                    this.cardSaveLoading = false;
                }
            });
        },
        getBillingDetails() {
            getBillingDetail().then((response) => {
                if (response.data !== null) {
                    this.billingDetail = response.data;
                    this.syncBillingForm();
                    this.noBillingDetail = false;
                    this.createCardForm = false;
                } else {
                    this.noBillingDetail = true;
                }
            });
        },
        syncBillingForm() {
            for (const key in this.billingDetail) {
                if (key in this.billingForm) {
                    this.billingForm[key] = this.billingDetail[key];
                }
            }
        },
    },
    mounted() {
        this.planVisible = !!this.$route.query["charge_id"];
        this.getBillingDetails();
        log("default lang is", this.defaultLang);
    },
    updated() {
        log.info("updated");
        if (this.$validator.locale !== this.$i18n.locale) this.$validator.localize(this.$i18n.locale);
    },
    watch: {},
};
</script>

<style lang="scss" scoped>
.new-theme {
    #billing {
        .actionButton {
            border: none;
            box-shadow: none;
        }
    }
}

.no-card-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 12px;

    &-text {
        margin: 16px 0;
        font-size: 16px;
        padding: 16px;
        max-width: 40%;
        text-align: center;
    }
}

.billing-card-title {
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
    padding: 4px;
}

.billing-card-content {
    color: rgba(0, 0, 0, 0.75);
    font-weight: 500;
    font-size: 16px;
    padding: 4px;
}

.fab {
    width: 50px;
    height: 50px;
    border-radius: 25px;
    background-color: white;
    position: absolute;
    bottom: 20px;
    left: 100px;
    z-index: 9999;
    transition: all 0.3s;
    box-shadow: 0 0 0 0 rgba(100, 100, 100, 1);
    transform: scale(1);
    animation: pulse 3s infinite;
    cursor: pointer;
}

@keyframes pulse {
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(100, 100, 100, 0.5);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px #00000000;
    }

    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 #00000000;
    }
}
</style>

<style>
.ant-table-body .ant-table-column-title {
    color: #181c32;
    font-size: 13px;
    font-weight: 300;
    font-family: Poppins;
    white-space: nowrap;
}

.md-select-menu {
    z-index: 9999999999999999999999 !important;
}
</style>
